export const DOOR_LABEL_IDS = new Set([101, 102, 103, 104, 105]);
export const VENT_LABEL_ID = 407;
export const SASH_LABEL_ID = 405;
